import _ from 'lodash'
import Backbone from 'backbone'
import template from './vi-simple-advanced.hbs'
import BoxOptions from 'scoreboard/components/box-options'
import i18n from 'scoreboard/components/i18n'
import FormView from 'scoreboard/components/form-view'

const ViSimpleAdvanced = Backbone.View.extend({

	/**
	 * The first step of the metric value import wizard: choose a simple or
	 * advanced import (#23317)
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Import} options.model
	 */
	initialize: function(options = {}) {
		this.options = options
		// #38611 provide a formView with allowCleanSubmission:true to ensure
		// that the "next" button will be enabled (see wizard.js renderFooter)
		this.formView = new FormView({
			el: this.el,
			allowCleanSubmission: true,
			submit: this.submit.bind(this)
		})
	},

	tagName: 'form',

	className: 'vi-simple-advanced',

	events: {
		'click .box-options-container li': 'onClickBoxOption'
	},

	render: function() {
		this.$el.empty().append(template(this.context()))
		this.options.wizard.render({
			formView: this.formView,
			el: this.el,
			stateSaver: this.saveState.bind(this)
		})
		this.renderBoxOptions()
		this.formView.start()
		return this
	},

	context: function () {
		let type = this.model.get('type')
		let key
		if (type === 'metric-value') {
			key = 'home.metricUpdates.importTooltip'
		} else if (type === 'initiative-status') {
			key = 'initiatives.overview.import'
		} else {
			key = 'admin.import.addImport'
		}
		return {title: i18n.get(key)}
	},

	renderBoxOptions: function() {
		// #38409 the Box Options will be labeled "Standard" and "Simple"
		this.boxOptions = new BoxOptions({
			availableOptions: [
				{
					value: 'advanced',
					title: 'admin.import.simpleAdvanced.advanced',
					icon: 'import-standard',
					subLabel: 'admin.import.simpleAdvanced.advanced.sublabel'
				},
				{
					value: 'simple',
					title: 'admin.import.simpleAdvanced.simple',
					icon: 'import-simple',
					subLabel: 'admin.import.simpleAdvanced.simple.sublabel'
				}
			]
		})
		this.$('.box-options-container').html(this.boxOptions.el)
		this.boxOptions.render()
		// #38409 the "Standard" (aka 'advanced') option should be selected by
		// default
		let advanced = _.get(this.model.attributes, 'advanced', true)
		let value = advanced ? 'advanced' : 'simple'
		this.boxOptions.val(value)
		// #48430 make sure the correct number of steps are displayed in the
		// wizard progress bar for the currently selected option
		this.onClickBoxOption()
	},

	onClickBoxOption: function() {
		let advanced = this.boxOptions.val() === 'advanced'
		let views = this.options.wizard.getViews(advanced)
		this.options.wizard._wizardProgress.toggleAnimation(false)
		let values = { steps: views.length }
		this.options.wizard._wizardProgress.setValues(values)
	},

	saveState: function() {
		let advanced = this.boxOptions.val() === 'advanced'
		this.model.set('advanced', advanced)
	},

	submit: function(e) {
		e.preventDefault()
		this.saveState()
		this.options.wizard.next()
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.boxOptions, this.formView], 'remove')
	}

})

export default ViSimpleAdvanced

ViSimpleAdvanced.__filename__ = 'imports/vi/vi-simple-advanced.js'
